/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Box_ScoreInputs */

const th_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติผู้เล่นในเกม`)
};

const en_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Player box score`)
};

const ja_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手のボックススコア`)
};

const zh_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球员数据`)
};

const es_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas por jugador`)
};

const pt_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas por jogador`)
};

const id_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik pemain`)
};

const fr_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuille de match par joueur`)
};

const tl_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box score`)
};

const vi_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê cầu thủ`)
};

const ko_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수 기록`)
};

const de_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielerstatistik`)
};

const ru_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика игроков`)
};

const tr_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncu istatistiği`)
};

const it_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche dei giocatori`)
};

const pl_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki zawodników`)
};

const uk_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика гравців`)
};

const hi_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ियों के आँकड़े`)
};

const ar_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصاءات اللاعبين`)
};

const ms_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik pemain`)
};

const bn_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলোয়াড়ের পরিসংখ্যান`)
};

const zh_tw2_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員數據`)
};

const zh_hk2_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員數據`)
};

const ur_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھلاڑیوں کے اعداد و شمار`)
};

const fa_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آمار بازیکنان`)
};

const sw_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takwimu za wachezaji`)
};

const nl_game_box_score = /** @type {(inputs: Game_Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelersstatistieken`)
};

/**
* | output |
* | --- |
* | "Player box score" |
*
* @param {Game_Box_ScoreInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const game_box_score = /** @type {((inputs?: Game_Box_ScoreInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Box_ScoreInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_game_box_score(inputs)
	if (locale === "ja") return ja_game_box_score(inputs)
	if (locale === "zh") return zh_game_box_score(inputs)
	if (locale === "es") return es_game_box_score(inputs)
	if (locale === "pt") return pt_game_box_score(inputs)
	if (locale === "id") return id_game_box_score(inputs)
	if (locale === "fr") return fr_game_box_score(inputs)
	if (locale === "tl") return tl_game_box_score(inputs)
	if (locale === "vi") return vi_game_box_score(inputs)
	if (locale === "ko") return ko_game_box_score(inputs)
	if (locale === "de") return de_game_box_score(inputs)
	if (locale === "ru") return ru_game_box_score(inputs)
	if (locale === "tr") return tr_game_box_score(inputs)
	if (locale === "it") return it_game_box_score(inputs)
	if (locale === "pl") return pl_game_box_score(inputs)
	if (locale === "uk") return uk_game_box_score(inputs)
	if (locale === "hi") return hi_game_box_score(inputs)
	if (locale === "ar") return ar_game_box_score(inputs)
	if (locale === "ms") return ms_game_box_score(inputs)
	if (locale === "bn") return bn_game_box_score(inputs)
	if (locale === "zh-TW") return zh_tw2_game_box_score(inputs)
	if (locale === "zh-HK") return zh_hk2_game_box_score(inputs)
	if (locale === "ur") return ur_game_box_score(inputs)
	if (locale === "fa") return fa_game_box_score(inputs)
	if (locale === "sw") return sw_game_box_score(inputs)
	if (locale === "nl") return nl_game_box_score(inputs)
	return en_game_box_score(inputs)
});